<h1 mat-dialog-title>{{data.message}}</h1>
<div mat-dialog-content>

</div>
<div mat-dialog-actions>
  <button mat-button style="margin-top:15px;" (click)="dialogRef.close(false)">Anuluj</button>
  <button mat-button style="margin-top:15px;" (click)="dialogRef.close(true)" color="primary"
    cdkFocusInitial>Potwierdź</button>
</div>